import { render, staticRenderFns } from "./checkboxControl.vue?vue&type=template&id=d131c146&scoped=true&"
import script from "./checkboxControl.ts?vue&type=script&lang=ts&"
export * from "./checkboxControl.ts?vue&type=script&lang=ts&"
import style0 from "./checkboxControl.vue?vue&type=style&index=0&id=d131c146&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d131c146",
  null
  
)

export default component.exports